import { useEffect, useState } from 'react'
import { z, ZodError, ZodType } from 'zod'

export const generateLinkSchemaChannels = z
    .object({
        linkName: z
            .string()
            .transform((val) => val || undefined)
            .optional(),
        budget: z.number().min(0, 'Budget cannot be negative').optional(),
        channelName: z.string().nullable().optional(),
    })
    .refine(
        (data) => {
            if (data.channelName) {
                return true
            }
            return (
                data.linkName &&
                data.linkName.length >= 2 &&
                data.linkName.length < 255
            )
        },
        {
            message: 'Either link name or special channel must be provided',
            path: ['linkName'],
        }
    )

export const generateLinkSchemaSites = z
    .object({
        linkName: z
            .string()
            .transform((val) => val || undefined)
            .optional(),
        budget: z.number().min(0, 'Budget cannot be negative').optional(),
        siteName: z.string().nullable().optional(),
    })
    .refine(
        (data) => {
            if (data.siteName) {
                return true
            }
            return (
                data.linkName &&
                data.linkName.length >= 2 &&
                data.linkName.length < 255
            )
        },
        {
            message: 'Either link name or special channel must be provided',
            path: ['linkName'],
        }
    )

const NO_ERRORS = {}

export const useGenerateLinkValidation = <T>(
    schemaGenerator: ZodType<any, any, any>
) => {
    const [errors, setErrors] = useState<Partial<Record<keyof T, string>>>({})

    const validate = (data: T) => {
        try {
            schemaGenerator.parse(data)
            setErrors(NO_ERRORS)
            return true
        } catch (e) {
            if (e instanceof ZodError) {
                const fieldErrors: Partial<Record<keyof T, string>> = {}

                e.issues.forEach((issue) => {
                    const path = issue.path[0] as keyof T
                    fieldErrors[path] = issue.message
                })

                setErrors(fieldErrors)
            }
            return false
        }
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            setErrors(NO_ERRORS)
        }, 1000)
        return () => clearTimeout(timeout)
    }, [errors])

    return {
        isValid: Object.keys(errors).length === 0,
        errors,
        validate,
    }
}
